import React, { forwardRef } from "react";
import { useQuery } from "@apollo/client";
import { SKILL_GROUP_MANY } from "../../../schema/skillGroup";
import { SkillGroup } from "../../../types";

import { Loading, Error } from "../../ui/Alerts";

const SkillGroupSelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(SKILL_GROUP_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.skillGroupMany.map((skillGroup: SkillGroup) => (
        <option key={skillGroup._id} value={skillGroup._id}>
          {skillGroup.name}
        </option>
      ))}
    </select>
  );
});

export default SkillGroupSelect;
